import {createAction, props} from '@ngrx/store';

import {StoreGlobalActionType} from './global-action.type';

export type IGlobalErrorActionStruct = {
	error: any;
	date: Date;
};

export const globalErrorGlobalAction = createAction(StoreGlobalActionType.GLOBAL_ERROR, props<IGlobalErrorActionStruct>());
